import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Footer from './components/Footer';
import ExitIntentModal from './components/ExitIntentModal';
import { LoadingProvider } from './context/LoadingContext';
import IntakeForm from './pages/IntakeForm';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ThankYou from './pages/ThankYou';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import Checkout from './pages/Checkout';
import PaymentConfirmation from './pages/PaymentConfirmation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import CookieConsent from './components/CookieConsent';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';

// Admin Pages
import Users from './pages/admin/Users';
import Documents from './pages/admin/Documents';

const AdminRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  
  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

function App() {

  return (
    <AuthProvider>
      <LoadingProvider>
        <div className="relative min-h-screen flex flex-col">
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<Homepage />} />
              {/* Public routes */}
              <Route path="/intake" element={<IntakeForm />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
              <Route path="/admin/users" element={<AdminRoute><Users /></AdminRoute>} />
              <Route path="/admin/documents" element={<AdminRoute><Documents /></AdminRoute>} />

              {/* Protected */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            </Routes>
          </div>
          <Footer />
          <ExitIntentModal />
          <CookieConsent />
        </div>
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App; 